<template>
  <v-flex md6 shrink>
    <h1 class="title title-rule">Daniel Devine</h1>
    <div class="subtitle-black">Full Stack developer based in Brisbane, Australia.</div>
  </v-flex>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Home', // set a title
      titleTemplate: '%s | DDEVnet.net', // title is now "My Example App - Yay!"
      htmlAttrs: {
        lang: 'en',
        amp: undefined // "amp" has no value
      }
    }
  }
</script>